import I18n, { localize } from '@omnica/i18n';

var DIRECTION;
(function (DIRECTION) {
    DIRECTION["HORIZONTAL"] = "horizontal";
    DIRECTION["VERTICAL"] = "vertical";
})(DIRECTION || (DIRECTION = {}));
var VIOLATION;
(function (VIOLATION) {
    VIOLATION[VIOLATION["NAN"] = 0] = "NAN";
    VIOLATION[VIOLATION["TOO_LARGE"] = 1] = "TOO_LARGE";
    VIOLATION[VIOLATION["TOO_SMALL"] = 2] = "TOO_SMALL";
})(VIOLATION || (VIOLATION = {}));

var decreaseBy$2 = "Decrease by {step}";
var increaseBy$2 = "Increase by {step}";
var canNotDecrease$2 = "The value can't be decreased";
var canNotIncrease$2 = "The value can't be increased";
var violation$2 = {
	nan: "The value is not a number",
	tooLarge: "The value is too large",
	tooSmall: "The value is too small"
};
var messages_en_GB = {
	decreaseBy: decreaseBy$2,
	increaseBy: increaseBy$2,
	canNotDecrease: canNotDecrease$2,
	canNotIncrease: canNotIncrease$2,
	violation: violation$2
};

var decreaseBy$1 = "Disminuir en {step}";
var increaseBy$1 = "Aumentar en {step}";
var canNotDecrease$1 = "El valor no puede ser disminuido.";
var canNotIncrease$1 = "El valor no puede ser aumentado";
var violation$1 = {
	nan: "El valor no es un número",
	tooLarge: "El valor es demasiado grande",
	tooSmall: "El valor es demasiado pequeño"
};
var messages_es_ES = {
	decreaseBy: decreaseBy$1,
	increaseBy: increaseBy$1,
	canNotDecrease: canNotDecrease$1,
	canNotIncrease: canNotIncrease$1,
	violation: violation$1
};

var decreaseBy = "Уменьшить на {step}";
var increaseBy = "Увеличить на {step}";
var canNotDecrease = "Значение не может быть уменьшено";
var canNotIncrease = "Значение не может быть увеличено";
var violation = {
	nan: "Значение не является числом",
	tooLarge: "Значение слишком большое",
	tooSmall: "Значение слишком маленькое"
};
var messages_ru_RU = {
	decreaseBy: decreaseBy,
	increaseBy: increaseBy,
	canNotDecrease: canNotDecrease,
	canNotIncrease: canNotIncrease,
	violation: violation
};

var fallback = 'en-GB';
var i18n = new I18n({
    messages: {
        'en-GB': messages_en_GB,
        'es-ES': messages_es_ES,
        'ru-RU': messages_ru_RU,
    },
    fallback: fallback,
});
var extend = function (i18n, options) {
    if (options === void 0) { options = null; }
    return options
        ? i18n.extend(options)
        : i18n;
};
var init = function (locale, options) {
    if (options === void 0) { options = null; }
    return localize(extend(i18n, options), locale);
};

var i18n$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fallback: fallback,
  init: init
});

var isNumeric = function (value) { return !isNaN(Number(value)); };
var normalize = function (value, _a) {
    var min = _a[0], max = _a[1];
    var parsed = Number(value);
    return isNaN(parsed)
        ? ''
        : Math.max(min, Math.min(max, parsed));
};
var counter = 0;
/**
 * @param prefix
 * @return Идентификатор, уникальный в рамках генерируемой функцией последовательности
 */
var uid = function (prefix) {
    if (prefix === void 0) { prefix = 'omnica-input-number'; }
    return "".concat(prefix, "-").concat(++counter);
};

export { DIRECTION, VIOLATION, i18n$1 as i18n, isNumeric, normalize, uid };
